// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturedPosts-module--container--2Mf-0","FeaturedPost":"FeaturedPosts-module--FeaturedPost--11yjf"};